module.exports = __webpack_public_path__ + "img/success.3fa4f9c1.svg";